/**
 * @file title-delimenter.component.tsx
 * @description Пункт бокового меню, который представляет собой линию-разделитель с текстом для группировки элементов меню
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-10
 * @dependencies []
 * @related-files []
 */

/**
 * Props для компонента разделителя с текстом
 */
interface ITitleDelimenterProps {
    /** Текст заголовка для разделителя */
    title: string;
}

export const TitleDelimeter = ({ title }: ITitleDelimenterProps) => (
    <div className="menuItemDelimeter py-[0.833vmin] text-[#6FA5C8] w-full">
        <span className="px-[0.8127vmin]">{title}</span>
    </div>
);
